/* 
  w - stands for platform web
  service - backend service name decided by the team
  clientErrorId - a specific id that will let us find the error in the fe code
  errorIdentifier - a specific id that will let us find the error in the be-service
*/
export const getErrorMessageCode = (error, service, clientErrorId) => {
  const {
    backendErrorIdentifier = '000',
    displayMessage, // can't use a default here since only undefined (and not null) triggers default value when destructuring.. :/
  } = error?.content || {}

  const statusCode = error?.response?.status

  const errorMessageObject = {
    message: displayMessage || 'Tyvärr gick något fel på vår sida, vänligen försök igen.',
    errorCode: `Felkod:(W-${service}:${clientErrorId}:${statusCode}:${backendErrorIdentifier})`,
  }

  return errorMessageObject
}
